import { gql } from '@/lib/graphql/gql'

export const DATABASE_DISPLAY_NAME_QUERY = gql`
  query DatabaseDisplayName($databaseName: String!) {
    database(name: $databaseName) {
      id
      type
      idCompany
      idProject
      name
      displayName
      cluster {
        id
        provider
      }
    }
  }
`
